__turbopack_context__.v({
  "bar": "Hamburger-module-scss-module__Lce2pq__bar",
  "burger": "Hamburger-module-scss-module__Lce2pq__burger",
  "hamburgerMenu": "Hamburger-module-scss-module__Lce2pq__hamburgerMenu",
  "open": "Hamburger-module-scss-module__Lce2pq__open",
});
